<template>
  <div class="add-person">
    <div class="title">
      {{ type == 1 ? "查看账号" : type == 2 ? "编辑账号" : "新增账号" }}
    </div>
    <a-form :form="form">
      <div class="content">
        <div class="content-l">
          <div class="content-title">
            <span class="line"></span>
            运营人员基本信息
          </div>
          <a-form-item
            label="用户名"
            :label-col="formItemLayout.labelCol"
            :wrapper-col="formItemLayout.wrapperCol"
          >
            <a-input
              v-decorator="[
                'name',
                { rules: [{ required: true, message: '请填写账号名称' }] }
              ]"
              :disabled="type === 1 || roleType === 0"
              placeholder="请输入用户名，支持英文、数字"
            />
          </a-form-item>
          <a-form-item
            label="密码"
            :label-col="formItemLayout.labelCol"
            :wrapper-col="formItemLayout.wrapperCol"
          >
            <a-input v-decorator="['password']" type="password" />
          </a-form-item>
          <a-form-item
            label="昵称"
            :label-col="formItemLayout.labelCol"
            :wrapper-col="formItemLayout.wrapperCol"
          >
            <a-input v-decorator="['nickName']" placeholder="请输入昵称" />
          </a-form-item>
          <a-form-item
            label="手机号"
            :label-col="formItemLayout.labelCol"
            :wrapper-col="formItemLayout.wrapperCol"
          >
            <a-input v-decorator="['phone']" placeholder="请输入手机号" />
          </a-form-item>
          <a-form-item
            label="头像"
            :label-col="formItemLayout.labelCol"
            :wrapper-col="formItemLayout.wrapperCol"
          >
            <div class="uploadLeft">
              <a-upload
                v-decorator="['imageUrl']"
                list-type="picture-card"
                class="avatar-uploader"
                :disabled="type === 1"
                :show-upload-list="false"
                :action="serveUrl"
                :headers="headers"
                :before-upload="beforeUpload"
                @change="handleChange"
              >
                <img v-if="imageUrl!=''" :src="imageUrl" alt="头像图片">
                <div v-else>
                  <a-icon :type="loadingIcon ? 'loading' : 'plus'" />
                  <div class="ant-upload-text">
                    上传图片
                  </div>
                </div>
              </a-upload>
              <div class="upload-tip">
                <a-icon class="tip-icon" type="info-circle" />  只能上传jpg/png格式文件，建议上传200px*200px
              </div>
            </div>
          </a-form-item>
          <a-form-item
            label="真实姓名"
            :label-col="formItemLayout.labelCol"
            :wrapper-col="formItemLayout.wrapperCol"
          >
            <a-input v-decorator="['realName']" placeholder="请输入真实姓名" />
          </a-form-item>
          <a-form-item
            label="权限分配"
            :label-col="formItemLayout.labelCol"
            :wrapper-col="formItemLayout.wrapperCol"
          >
            <div v-if="type === 1 || roleType === 0">
              <a-input v-decorator="['jurisdiction']" disabled />
            </div>
            <div v-else>
              <a-radio-group v-decorator="['jurisdiction', { initialValue: 1 }]">
                <a-radio :value="0">
                  区域
                </a-radio>
                <a-radio :value="1">
                  设备
                </a-radio>
              </a-radio-group>
            </div>
          </a-form-item>
          <a-form-item
            label="账号状态"
            :label-col="formItemLayout.labelCol"
            :wrapper-col="formItemLayout.wrapperCol"
          >
            <div v-if="type === 1 || roleType === 0">
              <a-input v-decorator="['isEnable']" disabled />
            </div>
            <div v-else>
              <a-radio-group v-decorator="['isEnable', { initialValue: 0 }]">
                <a-radio :value="0">
                  启用
                </a-radio>
                <a-radio :value="1">
                  禁用
                </a-radio>
              </a-radio-group>
            </div>
          </a-form-item>
          <a-form-item
            label="备注"
            :label-col="formItemLayout.labelCol"
            :wrapper-col="formItemLayout.wrapperCol"
          >
            <a-textarea
              v-decorator="['remark']"
              :auto-size="{ minRows: 2, maxRows: 3 }"
              :disabled="type === 1 || roleType === 0"
              :max-length="50"
              placeholder="这个人很懒，什么都没留下"
              rows="1"
            />
          </a-form-item>
        </div>
        <div class="content-r">
          <div class="content-title">
            <span class="line"></span>
            设备分配
          </div>
          <div class="mt50">
            <a-form-item
              label="选择区域"
              :label-col="{ span: 5 }"
              :wrapper-col="{ span: 16 }"
            >
              <a-cascader
                v-model="areaContain"
                :options="options"
                :load-data="loadData"
                :field-names="{
                  label: 'name',
                  value: 'id',
                  children: 'children'
                }"
                placeholder="请选择"
                change-on-select
              />
            </a-form-item>
          </div>
          <div v-if="treeData.length" class="tree">
            <!-- <a-tree
              ref="tree"
              v-model="checkedKeys"
              :checkable="type !== 1 && roleType !== 0"
              default-expand-all
              :tree-data="treeData"
              @check="onCheck"
            /> -->
            <a-form-item
              label="选择设备"
              :label-col="{ span: 5 }"
              :wrapper-col="{ span: 16 }"
            >
              <a-tree
                v-model="checkedKeys"
                checkable
                :expanded-keys="expandedKeys"
                :auto-expand-parent="autoExpandParent"
                :selected-keys="selectedKeys"
                :tree-data="treeData"
                @expand="onExpand"
                @select="onSelect"
              />
            </a-form-item>
          </div>
        </div>
      </div>
      <div class="btn-list">
        <a-button
          v-if="(type == 3 || type == 2) && roleType !== 0"
          type="primary"
          @click="handleSubmit"
        >
          保存
        </a-button>
        <a-button @click="handleGoBack">
          {{ type == 1 ? "返回" : "取消" }}
        </a-button>
      </div>
    </a-form>
  </div>
</template>
<script>
import Host from '@/config/apiHost'
import { addRole } from '@/api/system'
import { mapGetters } from 'vuex'
import { getArea } from '@/components/mixins/mixins.js'
const formItemLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 16 }
}
function getBase64 (img, callback) {
  const reader = new FileReader()
  reader.addEventListener('load', () => callback(reader.result))
  reader.readAsDataURL(img)
}
const treeData = [
  {
    title: '0-0',
    key: '0-0',
    children: [
      {
        title: '0-0-0',
        key: '0-0-0',
        children: [
          { title: '0-0-0-0', key: '0-0-0-0' },
          { title: '0-0-0-1', key: '0-0-0-1' },
          { title: '0-0-0-2', key: '0-0-0-2' }
        ]
      },
      {
        title: '0-0-1',
        key: '0-0-1',
        children: [
          { title: '0-0-1-0', key: '0-0-1-0' },
          { title: '0-0-1-1', key: '0-0-1-1' },
          { title: '0-0-1-2', key: '0-0-1-2' }
        ]
      },
      {
        title: '0-0-2',
        key: '0-0-2'
      }
    ]
  },
  {
    title: '0-1',
    key: '0-1',
    children: [
      { title: '0-1-0-0', key: '0-1-0-0' },
      { title: '0-1-0-1', key: '0-1-0-1' },
      { title: '0-1-0-2', key: '0-1-0-2' }
    ]
  },
  {
    title: '0-2',
    key: '0-2'
  }
]
export default {
  mixins: [getArea],
  data () {
    return {
      serveUrl: `${Host.uploadImgHost}/building/adv/upload`,
      headers: {
        token: ''
      },
      loadingIcon: false,
      baseHeadUrl: '',
      imageUrl: 'http://ito-boss-img.oss-cn-hangzhou.aliyuncs.com/material/20210430/161975019292620b221fcac664840a4cf09809f4a224d.png',
      type: 3, // 1 查看用户 2编辑用户 3 新建用户
      roleType: 1, // 1默认 0自建
      pageId: '',
      loading: false,
      confirmCheckedKeys: [],
      treeData,
      menuData: [],
      formItemLayout,
      form: this.$form.createForm(this),
      areaContain: [],
      options: [],
      expandedKeys: ['0-0-0', '0-0-1'],
      autoExpandParent: true,
      checkedKeys: ['0-0-0'],
      selectedKeys: []
    }
  },
  watch: {
    checkedKeys (val) {
      console.log('onCheck', val)
    }
  },
  created () {
    const { type, id } = this.$route.query
    this.type = parseInt(type)
    // this.roleType = parseInt(roleType)
    this.pageId = id
  },
  mounted () {
    this.load()
    this.getArea('', 2, null, true)
  },
  methods: {
    onExpand (expandedKeys) {
      console.log('onExpand', expandedKeys)
      // if not set autoExpandParent to false, if children expanded, parent can not collapse.
      // or, you can remove all expanded children keys.
      this.expandedKeys = expandedKeys
      this.autoExpandParent = false
    },
    onCheck (checkedKeys) {
      console.log('onCheck', checkedKeys)
      this.checkedKeys = checkedKeys
    },
    onSelect (selectedKeys, info) {
      console.log('onSelect', info)
      this.selectedKeys = selectedKeys
    },
    ...mapGetters(['token']),
    beforeUpload (file) {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg'
      if (!isJpgOrPng) {
        this.$message.error('您只能上传 JPG/PNG/JPEG 文件!')
      }
      const isLt10M = file.size / 1024 / 1024 < 5
      if (!isLt10M) {
        this.$message.error('图像必须小于5MB!')
      }
      return isJpgOrPng && isLt10M
    },
    handleChange (info) {
      if (info.file.status === 'uploading') {
        this.loadingIcon = true
        return
      }
      if (info.file.status === 'done') {
        if (info.file.response.result) {
          this.baseHeadUrl = info.file.response.result
        }
        getBase64(info.file.originFileObj, imageUrl => {
          this.imageUrl = imageUrl
          this.loadingIcon = false
        })
      }
    },
    loadData (selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1]
      this.getArea(targetOption.id, targetOption.layer + 1, targetOption, true)
    },
    load () {

    },
    handleSubmit (e) {
      e.preventDefault()
      const {
        form: { validateFields }
      } = this
      validateFields((err, values) => {
        if (!err) {
          const menuList = this.handleSubmitMenu()
          /* if (!menuList.length && this.roleType !== 0) {
            this.$message.error('抱歉菜单权限是必选')
            return false
          } */
          const params = {
            id: this.pageId,
            name: values.name,
            roleType: values.roleType === '自建' ? 1 : 0,
            remark: values.remark,
            isEnable: values.isEnable,
            roleMenuAddList: menuList
          }
          addRole(params).then(res => {
            const msg = this.pageId ? '账号信息修改成功' : '账号配置成功'
            this.$message.success(msg)
            this.handleGoBack()
          })
        }
      })
    },
    handleGoBack () {
      this.$router.replace('/system/operation/personConfig')
    }
  }
}
</script>
<style lang="stylus">
.upload-tip
  line-height 25px
.uploadLeft
  display flex
  align-items center
.ant-upload-picture-card-wrapper
  width auto !important
.add-person
  .ant-form label
    font-size 12px
  .ant-input
    font-size 12px
  .ant-tree
    font-size 12px
</style>
<style lang="stylus" scoped>
.add-person
  width 100%
  padding 10px
  background-color #fff
  .btn-list
    width 100%
    padding 30px 0
    text-align center
    button
      margin-left 10px
  .content
    width 100%
    height 690px
    border 1px solid #E6E6E6
    display flex
    border-radius 2px
    margin-top 16px
    .content-title
      font-size 12px
      color #333333
      font-weight 500
      margin-bottom 16px
    >div
      width 50%
    .content-l
      padding 10px 16px
      border-right 1px solid #E6E6E6
      .content-title
        display flex
        align-items center
        .line
          height 13px
          width 3px
          background-color #1890ff
          display flex
          margin-right 10px
    .content-r
      width 50%
      position relative
      .content-title
        display flex
        align-items center
        .line
          height 13px
          width 3px
          background-color #1890ff
          display flex
          margin-right 10px
      .mt50
        margin-top 43px
      .tree
        width 100%
        height 100%
        // padding 36px 16px
        overflow-y scroll
      .content-title
        position absolute
        padding 10px 16px
        width 80%
        z-index 9
        background-color #fff
</style>
